import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import * as fileSaver from "file-saver";

@Injectable({ providedIn: "root" })
export class DownloadService {
  loading = false;

  constructor(private httpService: HttpClient) {
  }

  public download(path:string, paramName:string|null, paramValues:string[]|null, fileName:string): Promise<boolean>  {
    return new Promise<boolean>(resolve => {
      if (paramName && paramValues && paramName.trim().length > 0 && paramValues.length > 0) {
        path = path + "?" + paramName + "=" + paramValues.join("~");
      }
      this.httpService.get(path, {
        responseType: "blob",
        headers: new HttpHeaders().append("Content-Type", "application/json"),
      }).subscribe(data => {
        fileSaver.saveAs(data, fileName);
        resolve(true);
      });
    });
  }

}
